import React, { useRef } from "react";

import styles from "./RegistrationInfoModal.module.scss";
import closeIcon from "../../../img/closeIcon.svg";
import { Button } from "../../Button/Button";
import { useCloseModal } from "../hooks";

const NEW_SERVICE_URL = "https://wwa-ios.com";

type Props = {
  hideModal: () => void;
};

export const RegistrationInfoModal: React.FC<Props> = ({ hideModal }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useCloseModal(modalRef, hideModal);

  const openNewService = () => window.open(NEW_SERVICE_URL, "_blank", "noopener,noreferrer");

  return (
    <div className="modal-background">
      <div className={styles.wrapper} ref={modalRef}>
        <div className="modal-titleContainer">
          <div className="modal-title">Регистрация отключена</div>
          <img
            src={closeIcon}
            alt="close icon"
            className="modal-closeIcon"
            onClick={hideModal}
          />
        </div>

        <div className={styles.badge}>
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 15L20 4" />
            <path d="M15 4h5v5" />
            <path d="M11 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5" />
          </svg>
        </div>

        <div className={styles.bold}>
          Доступен только вход для существующих пользователей
        </div>
        <div className={styles.regular}>
          Регистрация новых пользователей здесь отключена. Создание аккаунтов
          переехало на отдельный сервис.
        </div>

        <a
          className={styles.service}
          href={NEW_SERVICE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg className={styles.globe} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="9" />
            <path d="M3 12h18M12 3c2.5 2.7 2.5 15.3 0 18M12 3c-2.5 2.7-2.5 15.3 0 18" />
          </svg>
          <span className={styles.serviceText}>
            <b>wwa-ios.com</b>
            <span>Новый сервис</span>
          </span>
          <svg className={styles.arrow} viewBox="0 0 24 24" fill="none" stroke="currentColor"
               strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M7 17L17 7M8 7h9v9" />
          </svg>
        </a>

        <div className="modal-bottomWarapper">
          <Button onClick={openNewService}>Перейти на новый сервис</Button>
          <button type="button" onClick={hideModal} className="modal-closeBtn">Закрыть</button>
        </div>
      </div>
    </div>
  );
};
